import clsx from "clsx";
import { Outlet } from "react-router-dom";

import Background from "./Content/Background";
import { ArticleCards, FeatureCards } from "./Content/data";
import { ContentType } from "./Content/types";
import { getRandomInt } from "./Content/util";

export default function Template() {
  const randomContentType = ContentType.Featured;

  const contentList = randomContentType === ContentType.Featured ? FeatureCards : ArticleCards;

  const index = getRandomInt(0, contentList.length - 1);
  const content = contentList[index];

  return (
    <>
      <Background backgroundType={content.backgroundType} src={content.src}>
        <div
          className="grid max-lg:grid-cols-2 grid-cols-5 2xl:grid-cols-[320px_320px_auto_auto_auto]
                     max-sm:flex max-sm:flex-col-reverse max-sm:items-center max-sm:justify-end gap-6 max-sm:gap-0
                     p-[24px] max-sm:py-0 max-sm:p-0 w-full min-h-screen"
        >
          {/* LEFT PANEL (Outlet) */}
          <div
            className="col-span-2 max-lg:col-span-1 rounded-[12px] max-sm:rounded-none
                     bg-[#F7F7F7] w-full flex flex-col lg:h-full max-sm:flex-grow"
          >
            <div className="flex flex-col justify-center h-full max-sm:mx-[12px] max-sm:my-[48px] max-sm:mb-[60px] min-md:mx-[36px] xl:mx-[64px]">
              <Outlet />
            </div>
          </div>

          {/* TOP/RIGHT PANEL (Banner) */}
          <div className="flex flex-col w-full relative min-lg:col-span-3 overflow-hidden">
            <img src={content.src} className="hidden max-sm:block w-full h-full object-cover object-[0_30%]" />

            {/* Overlay */}
            <div
              className={clsx(
                "absolute inset-0 flex flex-col justify-center gap-[40px] max-sm:gap-[24px] w-full px-[12px]",
                content.type === "feature" && "items-center justify-center text-center",
                content.type === "article" && "items-start min-md:justify-end  min-md:ml-[40px]",
                content.overlayStyle,
             
              )}
            >
              <div
                className={clsx(
        "flex flex-col gap-[24px]",
    content.type === "feature" && "items-center max-sm:gap-0",
    content.type === "article" && "items-start max-sm:gap-[16px]",
    content.cardBgColor,
    content.cardBgColor &&
      "p-[24px] sm:p-[40px] rounded-[12px] max-w-[560px] w-1/2 max-[429px]:w-full"
                )}
              >
                {content.imageUrl && <img src={content.imageUrl} className="w-full max-h-[600px] object-contain" />}

                <span
                  className={clsx(
                    "leading-[114%]",
                    content.type === "feature" && "text-[55px] leading-[114%] max-sm:text-[35px]",
                    content.type === "article" && "text-[28px] leading-[114%] max-sm:text-[20px]",
                  )}
                >
                  {content.title}
                </span>
                <span
                  className={clsx(
                    "block text-[18px]",
                    content.descriptionStyle,
                    content.type === "feature" && "max-sm:hidden max-w-[500px]",
                  )}
                >
                  {content.description}
                </span>
              </div>

              {content.callToAction && (
                <a
                  href={content.linkUrl}
                  className={clsx(
                    "hover:bg-white hover:text-black focus:outline-4 focus:outline-[#8033FF] w-fit max-sm:text-[14px] text-nowrap max-sm:px-[16px] max-sm:py-[6px] px-[28px] py-[10px] text-center rounded-[999px] border-2 border-white",
                  )}
                >
                  {content.callToAction}
                </a>
              )}
            </div>
          </div>
        </div>
      </Background>
    </>
  );
}
